<hs-bulk-external-transactions-grid
  [isLoading]="isLoading"
  [data]="data"
  [transactionsLimitExceeded]="transactionsLimitExceeded"
  [updateStatuses]="updateStatuses$ | async"
  [(isSearchPopoverShown)]="isSearchPopoverShown"
  (clearTable)="clearTable()"
  (ignoreSelected)="onIgnore($event)"
  (unignoredSelected)="onUnignore($event)"
  (holdSelected)="onHold($event)"
  (unholdSelected)="onUnhold($event)"
  (cancel)="onCancelRequest()"
>
  <hs-find-transactions-popover
    (find)="onDownloadSubmit($event)"
    [bulkEditTranIds]="extTranIds"
  ></hs-find-transactions-popover>
</hs-bulk-external-transactions-grid>
